import { acoesListaCOM } from './registros/COM';
import { acoesListaFIS } from './registros/FIS';
import type { TelaRotina } from './tipoTelaRotina';

/**
 * Ações extras no cabeçalho da lista genérica de uma rotina do dicionário (ex.: COM070 "Importar XML"), por código de rotina. Cada módulo declara as suas no
 * próprio registro; o componente recebe o código e decide pela permissão do esquema.
 */
export const acoesListaRotina: Record<string, TelaRotina> = {
  ...acoesListaCOM,
  ...acoesListaFIS,
};
